import {
  IMatch,
  PlayValues,
} from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

export function isBracketCellOrderDirty(matches: IMatch[]): boolean {
  return matches.some((m) => {
    if (typeof m.id !== 'number') {
      return false;
    }
    const saved = m.savedBracketCellMatchIndex;
    if (saved === undefined) {
      return false;
    }
    return m.bracketCellMatchIndex !== saved;
  });
}

export function buildBracketCellReorderPayloads(
  sortedMatches: IMatch[],
): Array<{ id: number; bracketCellMatchIndex: number }> {
  if (!isBracketCellOrderDirty(sortedMatches)) {
    return [];
  }
  return sortedMatches
    .filter((m): m is IMatch & { id: number } => typeof m.id === 'number')
    .map((m) => ({
      id: m.id,
      bracketCellMatchIndex: m.bracketCellMatchIndex ?? 1,
    }));
}

export function applyBracketCellMatchOrder(
  tournamentMatches: PlayValues['tournamentMatches'],
  orderedMatchIds: Array<string | number>,
): PlayValues['tournamentMatches'] {
  const updated = { ...tournamentMatches };
  orderedMatchIds.forEach((id, index) => {
    const key = typeof id === 'number' ? id : Number(id);
    const match = updated[key];
    if (match) {
      updated[key] = { ...match, bracketCellMatchIndex: index + 1 };
    }
  });
  return updated;
}
